import React, { lazy } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
export const ServicesSection = () => {
  const services = [{
    title: 'Auto Wrappen',
    description: 'Transformeer uw auto met premium wraps en bescherm de originele lak met onze professionele wrapping service.',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/vPa5oULwHDcYzvNDCacQ1D/how-long-does-vinyl-wrap-last-1200x800-1-768x512.jpg',
    alt: 'Auto wrapping service - Professionele montage van vinyl wrap',
    price: '€1.250',
    link: '/diensten/autowrappen'
  }, {
    title: 'Ramen Tinten',
    description: 'Privacy en UV-bescherming met stijl. Hoogwaardige tinting voor een luxe uitstraling en optimaal comfort.',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/wNLF8ocqa3iPQaSqTR3jq1/carwindowtintingfranklintn-768x512.jpg',
    alt: 'Ramen tinten service - Vakkundige installatie van premium raamfolie',
    price: 'Vanaf €175',
    link: '/diensten/ramen-tinting'
  }, {
    title: 'Lichten Smoken',
    description: 'Geef uw auto een unieke, krachtige look met professioneel getinte lichten terwijl de originele lichtsterkte behouden blijft.',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7Sz73Ji6DM6jfsjFgLE8Pn/G22-CSL-Red-768x511.webp',
    alt: 'Lichten smoken service - BMW met stijlvolle gerookte achterlichten',
    price: 'Vanaf €130',
    link: '/diensten/lichten-smoken'
  }, {
    title: 'Ontchromen',
    description: 'Verwijder chrome elementen voor een cleane, moderne look die uw auto direct onderscheidt van de massa.',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8h8EqFfY6iTr2pX1pd2aXy/AS_Dechrome_Hero-768x512.jpg',
    alt: 'Ontchromen service - Matte zwarte auto met volledige chrome delete',
    price: '€349',
    link: '/diensten/ontchromen'
  }];
  return <section id="services" className="bg-[#0a0a0a] py-20" data-id="element-544">
      <div className="max-w-7xl mx-auto px-4 lg:px-6" data-id="element-545">
        <div className="text-center mb-12" data-id="element-546">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-547">
            Onze <span className="text-[#D6281F]" data-id="element-548">Diensten</span>
          </h2>
          <p className="text-[#CCCCCC] max-w-2xl mx-auto text-base" data-id="element-549">
            Premium car styling en customization door ervaren specialisten voor
            een unieke uitstraling.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-550">
          {services.map((service, index) => <Link key={index} to={service.link} className="group flex flex-col h-full bg-[#111111] overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-all duration-300" data-id="element-551">
              <div className="relative w-full" style={{
            paddingBottom: '56.25%'
          }} data-id="element-552">
                <img src={service.imageUrl} alt={service.alt} className="absolute inset-0 w-full h-full object-cover object-center transform group-hover:scale-105 transition-transform duration-500 ease-out" decoding="async" data-id="element-553" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" data-id="element-554"></div>
              </div>
              <div className="p-5" data-id="element-555">
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-556">
                  {service.title}
                </h3>
                <p className="text-[#CCCCCC] mb-4 text-sm" data-id="element-557">
                  {service.description}
                </p>
                <div className="inline-flex items-center text-white text-sm" data-id="element-558">
                  <span className="mr-2" data-id="element-559">Meer informatie</span>
                  <ArrowRightIcon size={14} data-id="element-560" />
                </div>
              </div>
            </Link>)}
        </div>
        <div className="mt-12 text-center" data-id="element-561">
          <Link to="/contact" className="inline-flex items-center bg-[#0f0f0f] border border-[#333] hover:bg-[#161616] text-white px-6 py-3 transition-colors duration-300 text-sm font-medium" data-id="element-562">
            <span className="mr-2" data-id="element-563">Persoonlijk advies nodig?</span>
            <ArrowRightIcon size={16} data-id="element-564" />
          </Link>
        </div>
      </div>
    </section>;
};